import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormArray, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProposalRequestVendorForm } from 'src/app/classes/form-groups/proposal-request-vendor-form';
import { Company, ProposalRequest } from 'src/app/classes/models';
import { LocalizationInfo } from 'src/app/interfaces/localization-info';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-add-proposal-request-non-vive-vendors-modal',
  templateUrl: './add-proposal-request-non-vive-vendors-modal.component.html',
  styleUrls: ['./add-proposal-request-non-vive-vendors-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddProposalRequestNonViveVendorsModalComponent implements OnInit {
  constructor(
    private ToastService: ToastService,
    private ActiveModal: NgbActiveModal,
    private UtilityService: UtilityService,
    private ElementReference: ElementRef
  ) {}

  @Input() Company!: Company;

  ProposalRequest!: ProposalRequest;
  ProposalRequestVendorFormArray = new FormArray<ProposalRequestVendorForm>([]);
  title: string = 'Add Unregistered Vendor';
  LocalizationInfo?: LocalizationInfo;
  country!: 'US' | 'CA';

  generateProposalRequestVendorForm() {
    const ProposalRequestVendorFormGroup = new ProposalRequestVendorForm();

    const { id: ProposalRequestId } = this.ProposalRequest;

    ProposalRequestVendorFormGroup.patchValue({ ProposalRequestId });

    const AddressFormGroup = ProposalRequestVendorFormGroup.controls['Address'];
    const { address1, city, state, zip } = AddressFormGroup.controls;
    // Set address validators.
    [address1, city, state, zip].forEach((control) =>
      control.setValidators([Validators.required])
    );

    return ProposalRequestVendorFormGroup;
  }

  close() {
    this.ActiveModal.dismiss();
  }

  save() {
    const errors = this.UtilityService.generateValidationErrorsObject(
      this.ProposalRequestVendorFormArray
    );

    if (errors) {
      throw this.ToastService.addErrorToast(
        'Error',
        'There is an error with a required field below.',
        { returnError: true }
      );
    }

    this.ActiveModal.close(this.ProposalRequestVendorFormArray);
  }

  addNonViveVendor() {
    this.ProposalRequestVendorFormArray.push(
      this.generateProposalRequestVendorForm()
    );
    const HostElement = this.ElementReference.nativeElement as HTMLElement;
    const { scrollHeight } = HostElement;

    // On the next digest cycle, scroll the element. This guarantees the element has been applied to the DOM
    // before scrolling.
    setTimeout(() => HostElement.scrollTo({ top: scrollHeight }), 0);
  }

  ngOnInit(): void {
    if (!this.Company) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing Client information.',
        { returnError: true }
      );
    }

    if (!this.ProposalRequest) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing Proposal Request information.',
        { returnError: true }
      );
    }

    const { country } = this.Company;

    if (!country) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing country information.',
        { returnError: true }
      );
    }

    this.LocalizationInfo = this.UtilityService.getLocalizedValuesMap(country);
    this.ProposalRequestVendorFormArray.push(
      this.generateProposalRequestVendorForm()
    );
    this.country = country;
  }
}
